import { Sun, Moon } from "lucide-react";

import { useSessionStore } from "@/entities/session";
import { ToggleGroup, ToggleGroupItem } from "@/shared/ui/toggle-group";
import { Theme } from "@/entities/session/types";

export const SwitchThemeButton = () => {
  const { theme, setTheme } = useSessionStore();

  return (
    <ToggleGroup type="single" value={theme} className="h-10">
      <ToggleGroupItem
        value={Theme.Light}
        onClick={() => {
          setTheme(Theme.Light);
        }}
        className={"w-full rounded-lg data-[state=on]:bg-primary"}
      >
        <p className="text-onPrimary">Светлая</p>
        <Sun className="text-onPrimary" />
      </ToggleGroupItem>
      <ToggleGroupItem
        value={Theme.Dark}
        onClick={() => {
          setTheme(Theme.Dark);
        }}
        className={"w-full rounded-lg data-[state=on]:bg-primary"}
      >
        <p className="text-textColor">Темная</p>
        <Moon
          className="stroke-textColor text-textColor"
          color={"text-textColor"}
        />
      </ToggleGroupItem>
    </ToggleGroup>
  );
};
